// (function ($) {

//     var h, v;
//     $(window).on("load", function () {
//         h = $("#imagehead").offset();
//         h = h.top;
//         v = window.innerHeight - h;

//         $("body.HomePage #imagehead").height( v );
//         $("body.HomePage #imagehead .background-video").css('transform', 'translate( 0, -'+ h.top +'px)' );

//     });

//     $(window).on("load resize scroll", function () {
//         let y = $(this).scrollTop();
//         let m = h - y;
//         if ( m > 0 ) {
//             $("#masthead").removeClass('fixed');
//         } else {
//             $("#masthead").addClass('fixed');
//         }

//     });

// })(jQuery);

(function ($) {

    var h, v;
    $(window).on("load", function () {
        h = $("#attic").height();
        // h = h.top;
        v = window.innerHeight - h;

        // $("body.HomePage #imagehead").height( v );
        // $("body.HomePage #imagehead .background-video").css('transform', 'translate( 0, -'+ h.top +'px)' );

    });

    $(window).on("load resize scroll", function () {
        let y = $(this).scrollTop();
        let m = h - y;
        if ( m > 0 ) {
            $("#masthead").removeClass('fixed');
        } else {
            $("#masthead").addClass('fixed');
        }

    });

})(jQuery);
